import { getToken } from "firebase/messaging";
import { messaging } from "./firebase";
import axios from "axios";
import { BaseUrl } from "./App";
import BuyerServicesUrl from "./BuyerServicesUrl";

export const getMyToken = async () => {
  try {
    const savedToken = localStorage.getItem("fcm_token");

    if (savedToken) {
      console.log("⚠️ already sent before");
      return;
    }

    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("❌ Notification permission denied");
      return;
    }

    // 🔥 أهم خطوة
    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );

    const token = await getToken(messaging, {
      vapidKey: "BCfBkhz_FDTAN58c_BL16zaY2Exdq9YBu-AlIZ94lwSYjIK6-X4F9A4SGb82oogAvy8K-zjeOutXiCbjVYtyD5I",
      serviceWorkerRegistration: registration, // 🔥 دي اللي كانت ناقصة
    });

    console.log("🔥 FCM TOKEN:", token);

    const userToken = localStorage.getItem("token");

    if (!userToken || !token) return;

    const formData = new FormData();
    formData.append("fcm_token", token);
    formData.append("type", "web");

    await axios.post(
      BaseUrl + BuyerServicesUrl.Notifications,
      formData,
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          Accept: "application/json",
        },
      }
    );

    localStorage.setItem("fcm_token", token);

    console.log("✅ token sent to backend");
  } catch (error) {
    console.log("❌ FULL ERROR:", error.response?.data);
  }
};